// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/screens/AdminRegistration/components/ErrorMsg/index.css
// module id = 3130
// module chunks = 0